import { observer } from "mobx-react-lite";
import { Button, Icon } from "semantic-ui-react";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useStore } from "../../app/stores/store";
import { Link } from "react-router-dom";
import { Form, Formik, FieldArray, Field } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { CheckboxToggle } from 'react-rainbow-components';
import { MySelectInput, valor, MySelectInputControl, MySelectInputEdiciones, } from "../../app/common/form/MySelectInput";
import { createCATConvenios, createCATConveniosFormValues, } from "../../app/models/CATConveniosCreate";
import React, { useEffect, useState, ChangeEvent } from "react";

import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import "../Convenios/src/css/convenios.css";

import addDepIcon from "../Convenios/src/imgs/plus-circle.svg";
import addDescIcon from "../Convenios/src/imgs/percent-circle.svg";

import { InstitucionesPublicasNumero } from "../../app/common/options/InstitucionesPublicasConvenio";
import { MyTextInputConv, MyTextAreatConv } from "../../app/common/form/MyTextInput";
import AddModalDependencias from "./Handlers/addDependencia";
import { RegionalBannerCentral } from '../Portafolio/Handlers/RegionalBannerCentral';
import { myBreadCrumbsConvInte } from './Handlers/BreadCrumbsConv';
import UploadFileModal from "./Handlers/uploadFilesModal";
import Footer from "../Footer";

const apiURL = process.env.REACT_APP_API_URL;
const activeC: string = "Crear Código"
let soliID: any;
let dependencias: any = [];

let exoneracion = [
  { index: 1, text: "Institucion", key: 1000, value: "0" },
  { index: 2, text: "Estudiante", Key: 2000, value: "1" },
];

let pcosto: any;
let participanteS: any;
let calcular: any = 0;

let descuentoP: any;
let descuentoCalc: any = 0;

let dBase: any;
let mAbase: any;
let montoCalc: any = 0;

let tipoConv: any = 0;

interface ConvData {
  id: number;
  descripcion: string;
  sgtEntidad: number;
}

export default observer(function CreateConvenios() {

  const URLDep = apiURL + `/SGTDependencias`;
  const [dependencia, setDependencia] = useState([]);
  const [depen, setDepen] = useState(0);
  const [solEnti, setSolEnti] = useState(0);

  const [switchState, setSwitchState] = useState<boolean>(false);

  const fun2 = () => {
    if (valor()) {
      setDepen(valor());
    }
  };

  const getDependencias = async () => {
    const resp = await fetch(URLDep);
    const dataD = await resp.json();
    const newData = dataD
      .filter((depend: any) => depend.sgtEntidadIdEntidad == depen)
      .map((element: any) => ({
        text: element.dependencia,
        value: element.id
      }));
    setDependencia(newData);
  };

  // const getDependencias = async () => {
  //   const resp = await fetch(URLDep);
  //   const dataD = await resp.json();
  //   const DataF = dataD.filter(
  //     (depend: any) => depend.sgtEntidadIdEntidad == depen
  //   );
  //   DataF.map((element: any) => {
  //     var tran = { text: element.dependencia, value: element.id };
  //     dependencias.push(tran);
  //   });
  //   setDependencia(dependencias);
  // };

  useEffect(() => { getDependencias() }, [depen]);

  const { CATConveniosStore } = useStore();
  const URLConv = apiURL + `/CATSolicitudConvenios/`;
  const [solicitud, setSolicitud] = useState([]);
  var solicitudes: any = [];

  const getDetallesSoliciud = async () => {
    const resp = await fetch(URLConv);
    const dataS: ConvData[] = await resp.json();

    dataS.map((element) => {
      var tran = {
        text: "No. Solicitud " + element.id + " -- " + element.descripcion,
        value: element.id,
      };
      solicitudes.push(tran);
    });

    setSolicitud(solicitudes);
  }; useEffect(() => { getDetallesSoliciud(); }, []);

  const fun3 = async () => {
    if (valor()) {
      const resp = await fetch(URLConv);
      const dataS: ConvData[] = await resp.json();
      const solicitudFiltrada = dataS.find(
        (solicitudd: any) => solicitudd.id === valor()
      );
      if (solicitudFiltrada) {
        const sgtentidad: number = solicitudFiltrada.sgtEntidad;
        setSolEnti(sgtentidad);
      } else {
      }
      soliID = solicitudFiltrada?.id;
    }
  };

  const [entiFilter, setentiFilter] = useState("");
  const EntidadF: any = [];

  useEffect(() => {
    const entidadFiltrada = InstitucionesPublicasNumero.find(
      (entidadd: any) => entidadd.value === solEnti
    );
    const nameEntidadFiltered = entidadFiltrada
      ? { text: entidadFiltrada.text, value: entidadFiltrada.value }
      : null;
    if (nameEntidadFiltered) {
      EntidadF.push(nameEntidadFiltered);
      setentiFilter(EntidadF);
    }
  }, [solEnti]);

  let {
    createConvenios,
    loading,
    getEdicionesConvenios,
    CATEdicionesByCodigo,
  } = CATConveniosStore;

  const [convenioCr] = useState<createCATConvenios>(
    new createCATConveniosFormValues()
  );

  const validationSchema = Yup.object({
    catEdicionesId: Yup.string().required("Obligatorio"),
    monto: Yup.number().required("Obligatorio"),
  });

  var ediciones: any = [];

  CATEdicionesByCodigo.filter((edicion) => edicion.is_active).map((edicion) => {
    var info = edicion.catCursos.nombre;
    var tran = {
      text: info,
      value: edicion.id,
      is_active: edicion.is_active.toString(),
      key: edicion.id,
    };
    ediciones.push(tran);
  });

  const [montoEdi, setMontoEdi] = useState(0);

  const fun1 = () => {
    if (valor()) {
      const edicionFiltrada = CATEdicionesByCodigo.find(
        (ediciones) => ediciones.id === valor()
      );
      const montoCurso = edicionFiltrada?.listaCuotas?.[0]?.monto;
      setMontoEdi(montoCurso);
    }
  };

  useEffect(() => { }, [montoEdi]);
  useEffect(() => { getEdicionesConvenios() }, [getEdicionesConvenios]);

  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowD, setModalShowD] = useState(false);
  const [calculos, setCalculos] = useState();

  function calculo() {
    pcosto = (document.getElementById("pcosto") as HTMLInputElement).value;
    participanteS = (document.getElementById("participante") as HTMLInputElement).value;
    let multiplicar = pcosto * participanteS;
    calcular = multiplicar;
    setCalculos(calcular);
  }

  const [descuentoB, setDescuento] = useState();
  function calculoDescuento() {
    descuentoP = (document.getElementById("convenio.descuento") as HTMLInputElement).value;
    let descuentoN = (descuentoP / 100) * calcular;
    descuentoCalc = descuentoN;

    if (descuentoP >= 1) {
      tipoConv = 1
    } else { tipoConv = 0 }

    setDescuento(descuentoCalc);
    setTimeout(montotCalculo, 250);
  }

  const [montot, setMontot] = useState();
  function montotCalculo() {
    mAbase = (document.getElementById("monto") as HTMLInputElement).value;
    dBase = (document.getElementById("dbase") as HTMLInputElement).value;
    let montoTotal = mAbase - dBase;
    montoCalc = montoTotal;
    setMontot(montoCalc);
  }

  function crear(CCTOperacion: createCATConvenios) {
    let newConvenio: createCATConvenios = {
      pagado: CCTOperacion.pagado,
      monto: calcular,
      descuento: descuentoP,
      participantes: participanteS,
      tipoConvenio: tipoConv,
      catEdicionesId: CCTOperacion.catEdicionesId,

      sgtEntidadIdEntidad: CCTOperacion.sgtEntidadIdEntidad,
      codigoInstitucional: CCTOperacion.codigoInstitucional,
      documentoContable: CCTOperacion.documentoContable,
      sgtDependencia: CCTOperacion.sgtDependencia,
      descripcion: CCTOperacion.descripcion,
      fechaInicio: CCTOperacion.fechaInicio,
      fechaFinal: CCTOperacion.fechaFinal,
      pagoExoneracion: CCTOperacion.pagoExoneracion,
      solicitudId: CCTOperacion.solicitudId,
    };
    createConvenios(newConvenio);
  }

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSwitchState(event.target.checked);
  };

  function showExArea() {
    let formSection = document.getElementById("showExArea") as HTMLDivElement;
    formSection.classList.add("ver-seccion-form");
  }

  function showHidArea() {
    let formSection = document.getElementById("showExArea") as HTMLDivElement;
    formSection?.classList.remove("ver-seccion-form");
  }

  useEffect(() => {
    if (switchState) {
      showExArea();
    } else {
      showHidArea();
    }
  }, [switchState]);

  if (CATConveniosStore.loadingInitial)
    return <LoadingComponent content="Cargando..." />;

  return (
    <>

      <Container className="solicitudes-area-head head-institu">

        <div className="title-area-institu solicitudes-area-head" >
          <h2>Crear nuevo código</h2>
        </div>

        <div className="bread-institu-internals">
          {myBreadCrumbsConvInte(activeC)}
        </div>

      </Container>

      <Container className="detalle_convenio-area">
        <Container className="convenio-form-area">
          <div className="form-header">
            <h2>Crear código</h2>
            <hr />
            <h3>
              Los valores de éste formulario, son almacenados como parte del
              código institucional, posteriormente serán utilizados para generar la
              cotización
            </h3>
          </div>

          <div className="convenio-form">
            <Formik
              initialValues={convenioCr}
              enableReinitialize
              onSubmit={(values, { resetForm }) => {
                crear(values);
                resetForm({
                  values: {
                    pagado: false,
                    monto: 0,
                    descuento: 0,
                    tipoConvenio: 0,
                    participantes: 0,
                    catEdicionesId: 0,
                    pagoExoneracion: 0,
                    sgtEntidadIdEntidad: "",
                    codigoInstitucional: "",
                    documentoContable: "",
                    sgtDependencia: "",
                    descripcion: "",
                    fechaInicio: "",
                    fechaFinal: "",
                    solicitudId: 0,
                  },
                });
              }}
            >
              {({
                handleSubmit,
                isValid,
                isSubmitting,
                dirty,
                handleChange,
                handleBlur,
              }) => (
                <>
                  <div className="hidden-values"></div>
                  <Form
                    className="ui form"
                    onSubmit={ handleSubmit }
                    autoComplete="off"
                  >
                    <Row>
                      <Col xs={12} className="sect2">
                        <MySelectInputEdiciones
                          functionevent={fun3}
                          label="Solicitud"
                          id="solicitudId"
                          name="solicitudId"
                          placeholder={"- Selecciona una opción -"}
                          options={solicitud}
                        />
                      </Col>
                      <Col xs={12} className="entidad_convenio">
                        <MySelectInputEdiciones
                          functionevent={fun2}
                          label="Entidad"
                          id="sgtEntidadIdEntidad"
                          name="sgtEntidadIdEntidad"
                          placeholder={"- Selecciona una opción -"}
                          options={entiFilter}
                        />
                      </Col>
                    </Row>

                    <Row className="create-conv-form conv-form-dep-area">
                      <Col xs={10} className="sect2">
                        <MySelectInputControl
                          label="Dependencia"
                          id="sgtDependencia"
                          name="sgtDependencia"
                          placeholder={"- Selecciona una opción -"}
                          options={dependencia}
                        />
                      </Col>

                      <Col xs={2} className="sect3">
                        <p>Agregar:</p>
                        <div>
                          <Image
                            src={addDepIcon}
                            onClick={() => setModalShowD(true)}
                            alt={"Agregar dependencia"}
                          />
                        </div>
                      </Col>
                    </Row>

                    <MySelectInputEdiciones
                      functionevent={fun1}
                      label="Edición del curso"
                      id="catEdicionesId"
                      name="catEdicionesId"
                      placeholder="Selecciona una edición"
                      options={ediciones}
                    />

                    <Row>
                      <Col className="selecciona-fecha">
                        <MyTextInputConv
                          label="Inicio de curso"
                          placeholder=""
                          type="date"
                          id="fechaInicio"
                          name="fechaInicio"
                        />
                      </Col>

                      <Col className="selecciona-fecha">
                        <MyTextInputConv
                          label="Fin del curso"
                          placeholder=""
                          type="date"
                          id="fechaFinal"
                          name="fechaFinal"
                        />
                      </Col>
                    </Row>

                    <Row className="row-modalidad create-conv-form">
                      <Col>
                        <MyTextInputConv
                          value={montoEdi}
                          placeholder="Q.00"
                          label="Costo por participante"
                          name="pcosto"
                          id="pcosto"
                          onChange={() => {
                            calculo();
                            calculoDescuento();
                          }}
                        />
                      </Col>

                      <Col>
                        <MyTextInputConv
                          placeholder="00"
                          label="Cantidad de participantes"
                          name="participanteS"
                          id="participante"
                          onChange={() => {
                            calculo();
                            calculoDescuento();
                          }}
                        />
                      </Col>

                      <Col>
                        <MyTextInputConv
                          placeholder="Q.00"
                          label="Monto"
                          name="monto"
                          id="monto"
                          value={calculos}
                        />
                      </Col>

                      {/* <Col xs={2} className="sect3">
                        <p>¿Exoneración?</p>
                        <div>
                          <Image
                            src={addDescIcon}
                            onClick={showExArea}
                            alt={"exoneración"}
                          />
                        </div>
                      </Col> */}

                        <Col xs={2} className="sect3 switch-area">
                          <p>¿Exoneración?</p>
                          <CheckboxToggle
                            className="switch-form-conv"
                            value={switchState}
                            onChange={handleSwitchChange}
                          />

                        </Col>

                    </Row>

                    <Col className="exo-area" id="showExArea">
                      <Row>
                        <Col>
                          <label>Exoneración %</label>
                          <select
                            name="convenio.descuento"
                            id="convenio.descuento"
                            onChange={() => {
                              calculo();
                              calculoDescuento();
                            }}
                          >
                            <option
                              id="0"
                              value={0}
                              label=" - Selecciona -"
                              className="opcion-select"
                            >
                              Selecciona un porcentaje{" "}
                            </option>

                            <option
                              id="5"
                              value={5}
                              label="5%"
                              className="opcion-select"
                            >
                              5%{" "}
                            </option>

                            <option
                              id="10"
                              value={10}
                              label="10%"
                              className="opcion-select"
                            >
                              10%{" "}
                            </option>

                            <option
                              id="15"
                              value={15}
                              label="15%"
                              className="opcion-select"
                            >
                              15%{" "}
                            </option>

                            <option
                              id="20"
                              value={20}
                              label="20%"
                              className="opcion-select"
                            >
                              20%{" "}
                            </option>

                            <option
                              id="25"
                              value={25}
                              label="25%"
                              className="opcion-select"
                            >
                              25%{" "}
                            </option>

                            <option
                              id="50"
                              value={50}
                              label="50%"
                              className="opcion-select"
                            >
                              50%{" "}
                            </option>

                            <option
                              id="75"
                              value={75}
                              label="75%"
                              className="opcion-select"
                            >
                              75%{" "}
                            </option>
                            <option
                              id="90"
                              value={90}
                              label="90%"
                              className="opcion-select"
                            >
                              90%{" "}
                            </option>
                            <option
                              id="100"
                              value={100}
                              label="100%"
                              className="opcion-select"
                            >
                              100%{" "}
                            </option>
                          </select>
                        </Col>

                        <Col>
                          <MyTextInputConv
                            label="Descuento"
                            placeholder="Q. 000"
                            type="input"
                            id="dbase"
                            name="dbase"
                            value={descuentoB}
                          />
                        </Col>

                        <Col>
                          <MyTextInputConv
                            label="Total a pagar"
                            placeholder="Q. 000"
                            type="input"
                            id="total"
                            name="total"
                            value={montot}
                          />
                        </Col>

                        <Col>
                          <MySelectInputControl
                            label="Responsable del pago"
                            id="pagoExoneracion"
                            name="pagoExoneracion"
                            placeholder={"- Selecciona -"}
                            options={exoneracion}
                          />
                        </Col>

                        <MyTextInputConv
                          placeholder=""
                          type="hidden"
                          id="tipoConvenio"
                          name="tipoConvenio"
                          value={0}
                        />

                        <MyTextInputConv
                          placeholder=""
                          type="hidden"
                          id="pagado"
                          name="pagado"
                          value={0}
                        />

                        <MyTextInputConv
                          placeholder=""
                          type="hidden"
                          id="documentoContable"
                          name="documentoContable"
                          value={""}
                        />

                      </Row>
                    </Col>

                    <MyTextAreatConv
                      label="Descripción del código institucional"
                      placeholder=""
                      type="textarea"
                      id="descripcion"
                      name="descripcion"
                    />

                    <Row className="form-convenios-footer-btns justify-content-between">
                      {/* <Col sm={4}>
                        <Link to="/cargapagos/:id/lista-convenios">
                          <Button animated className="secondary">
                            <Button.Content visible>
                              Ver convenios
                            </Button.Content>
                            <Button.Content hidden>
                              <Icon name="arrow left" />
                            </Button.Content>
                          </Button>
                        </Link>
                      </Col> */}

                      <Col sm={4} className="crear-conv-area-btn">
                        {/* <Button
                          className="primary"
                          type="button"
                          animated
                          onClick={() => setModalShow(true)}
                        >
                          <Button.Content visible>
                            Cargar archivos
                          </Button.Content>
                          <Button.Content hidden>
                            <Icon name="file pdf outline" />
                          </Button.Content>
                        </Button> */}
                      </Col>

                      <Col sm={12} className="crear-conv-area-btn">
                        <Button
                          className="primary"
                          loading={loading}
                          type="submit"
                          animated
                        >
                          <Button.Content visible>
                            Crear código
                          </Button.Content>
                          <Button.Content hidden>
                            <Icon name="handshake outline" />
                          </Button.Content>
                        </Button>
                      </Col>
                    </Row>

                    <AddModalDependencias
                      show={modalShowD}
                      onHide={() => { setModalShowD(false); getDependencias(); }}
                      valor={depen}
                    />

                  </Form>
                </>
              )}
            </Formik>
          </div>
        </Container>
      </Container>

      <UploadFileModal
        onHide={() => { setModalShow(false) }}
        show={modalShow}
        solicitudID={soliID}
        CType={"CATConvenio"}
        insti={null}
      />

    </>
  );
});


